import React from "react";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { BsChatLeftTextFill } from "react-icons/bs";
import { HiMiniShoppingBag } from "react-icons/hi2";
import { BsClipboard2MinusFill } from "react-icons/bs";
import clipboard from "../../assets/image/clipboard.svg";
import clipboardBlue from "../../assets/image/clipboardBlue.svg";
import shoppingBag from "../../assets/image/shoppingBag.png";


const CardTotal = ({ type, title, number, explaination }) => {
  // 1. Define your icons mapping here (Outside the return)
  const images = {
    1: clipboard,
    2: clipboardBlue,
    3: shoppingBag,
  };

  // 2. Define colors based on type (Optional, to match your previous design)
  const textColors = {
    1: "text-[#634C05]",
    2: "text-[#051F33]",
    3: "text-[#662800]",
  };
  const CardColors = {
    1: "bg-[#FFE9A6]",
    2: "bg-[#ADD3F2]",
    3: "bg-[#FFDAC2]",
  };

  return (
    <div
      className={`flex flex-col justify-between h-32 gap-5 font-inter p-6 rounded-2xl shadow-lg ${
        CardColors[type] || "text-gray-700"
      }`}
    >
      {/* Use the dynamic color class */}
      <div
        className={`flex gap-3 items-center ${
          textColors[type] || "text-gray-700"
        }`}
      >
        {/* 3. Render the icon by looking it up in the object */}
        {/* {icons[type] || <HiOutlineDocumentReport className="w-7 h-7" />} */}
        {
          <img
            src={images[type] || "/assets/image/clipboard.png"}
            className="w-8 h-8 object-contain"
            value={type}
          />
        }

        <p className="font-semibold text-xl">{title}</p>
      </div>

      <div className="flex items-baseline gap-3">
        <p
          className={`text-4xl font-semibold ${
            textColors[type] || "text-gray-700"
          } `}
        >
          {number}
        </p>
        <span className="text-[#8d7b6f] font-medium text-lg">
          {explaination}
        </span>
      </div>
    </div>
  );
};

export default CardTotal;
